<div class="rest_dra">
    <div class="frm_date_dra">
        <div class="page-title-bar mb-4 flex-sm-row flex-column flex-wrap d-flex justify-content-between align-items-start">
            <div class="title d-flex align-items-center">
              <button  mat-icon-button (click)="navigate()"  class="me-3">
                <mat-icon class="material-icons-round">arrow_back</mat-icon>
              </button>
              <div>
                <h1 >{{ 'inventory_report.title' | translate }}</h1>
                <h2 class="m-0" *ngIf="pageSubTitle">{{pageSubTitle}}</h2>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="headerCustomTemplate"></ng-container>
            
            <button *ngIf="showButton" mat-button >{{showButton}}</button>
          </div>
        <div class="sfafd">
            <!-- <div class="col-sm-5">
                <div class="res_fll_sed">
                    <div class="row">
                        <div class="col-sm-1">
                            <label>{{ 'inventory_report.from' | translate }}</label>
                        </div>
                        <div class="col-sm-5" style="
                        padding-left: 20px;
                    ">
                            <input type="date" name="fromDate" [(ngModel)]="fromDate">
                        </div>

                        <div class="col-sm-1">
                            <label class="ret_tde">{{ 'inventory_report.to' | translate }}</label>
                        </div>
                        <div class="col-sm-5" style="
                        padding-left: 20px;
                    ">
                            <input type="date" name="toDate" [(ngModel)]="toDate" [max]="today">
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="in_btn_dra">
                    <button (click)="search()">{{ 'inventory_report.search' | translate }}</button>
                </div>
            </div>
           <div class="col-sm-1"></div> -->
    
            <div class="date-range-form">
                <div class="nw_all">
                <mat-form-field appearance="outline" (click)="fromDatePicker.open()">
                  <mat-label>From Date</mat-label>
                  <input matInput [matDatepicker]="fromDatePicker" name="fromDate" [(ngModel)]="fromDate" readonly>
                  <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #fromDatePicker></mat-datepicker>
                </mat-form-field>
             </div>
             <div class="nw_all">
                <mat-form-field appearance="outline" (click)="toDatePicker.open()">
                  <mat-label>To Date</mat-label>
                  <input matInput [matDatepicker]="toDatePicker" name="toDate" [(ngModel)]="toDate" [max]="today" readonly>
                  <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #toDatePicker></mat-datepicker>
                </mat-form-field>
                </div>
             
          </div>
          <div class="search_pag">
            <button (click)="search()" mat-flat-button color="primary" type="submit">{{ 'inventory_report.search' | translate }}</button>
        </div>
         <div class="adas" style="display: flex;
           justify-content: end;
           gap: 15px;">
            <!-- <mat-select style="border: 1px solid lightgray;
            padding: 7px 5px;
            border-radius: 5px; max-width: 130px; background: #fff;" [(value)]="selectedFrequency" [(ngModel)]="selectedFrequency" (ngModelChange)="changeFrequency()">
                <mat-option [value]="1" >
                  Daily
                </mat-option>
                <mat-option [value]="2">
                  Monthly
                </mat-option>
              </mat-select>

              <mat-select style="border: 1px solid lightgray;
              padding: 7px 5px;
              border-radius: 5px;max-width: 130px;background: #fff;" [(value)]="selectedView">
                  <mat-option value="Data" >
                    Data View
                  </mat-option>
                  <mat-option value="Graph">
                    Graph View
                  </mat-option>
                </mat-select> -->
           </div>
         
        </div>
    </div>
    
</div>

<mat-card appearance="outlined" *ngIf="visible">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="inventoryActivityReportData"
           [showPagination]="true" [itemsPerPage]="25">
      </sm-data-table>
    </div>
  </mat-card>
  <!-- <sm-line-chart></sm-line-chart> -->

